import styled from 'styled-components';

import { Flex } from '@zillow/constellation';

export const StyledFlex = styled(Flex)`
    max-width: 450px;
`;
